import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import api from "../api";
import { Route } from "lucide-react";

export default function TodayBriefCard() {
  const navigate = useNavigate();
  const [brief, setBrief] = useState(null);
  useEffect(() => {
    api.get(`/comm/daily-brief?base_url=${encodeURIComponent(window.location.origin)}&days=3`)
      .then((r) => setBrief(r.data.summary)).catch(() => setBrief(null));
  }, []);
  if (!brief) return null;
  return (
    <Card data-testid="today-brief-card" onClick={() => navigate("/daily-brief")}
      className="cursor-pointer border-l-4 border-l-indigo-500 p-5 transition-all hover:-translate-y-0.5 hover:shadow-md">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <Route size={18} className="text-indigo-600" />
          <h3 className="font-head text-lg font-semibold text-slate-900">Oggi</h3>
        </div>
        <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
          <span data-testid="today-ready"><b className="text-emerald-600">{brief.pronti}</b> messaggi pronti</span>
          <span data-testid="today-blocked"><b className="text-amber-600">{brief.bloccati}</b> attività bloccate</span>
          <span data-testid="today-arrivals"><b className="text-cyan-700">{brief.arrivi}</b> arrivi</span>
          <span data-testid="today-departures"><b className="text-violet-700">{brief.partenze}</b> partenze</span>
        </div>
        <span className="text-xs font-medium text-indigo-600">Apri riepilogo →</span>
      </div>
    </Card>
  );
}
